(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('numberFilterValue', numberFilterValue);

    function numberFilterValue() {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '='
            },
            controller: numberFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/number',
            link: numberFilterValueLink
        };

        function numberFilterValueLink(scope, elem) {

            elem.on('focus', 'input[type=number]', function () {
                angular.element(this).on('mousewheel.disableScroll', function (e) {
                    e.preventDefault();
                });
            });
            elem.on('blur', 'input[type=number]', function () {
                elem.find('input[type=number]').off('mousewheel.disableScroll');
            });

            scope.$on('$destroy', function() {
               elem.off('blur');
               elem.off('focus');
            });
        }
    }

    function numberFilterValueCtrl() {
    }
})();